import { useContext } from 'react';
import { StateContext } from '../../state/contexts';
import useFilters from './use-filters';
import { Filters } from '../../config/types/config';
import Job from '../../jobs/types/job';

const useFiltersWithout = (key: keyof Filters<any>): Job[] => {
  const state = useContext(StateContext);
  const { filters, jobs } = state;
  const { fetched } = jobs;
  return useFilters(fetched, {
    ...filters,
    [key]: {
      ...filters[key],
      selected: [],
    },
  });
};

export default useFiltersWithout;
